import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          'Order Management System': 'Order Management System',
          Dashboard: 'Dashboard',
          Admin: 'Admin',
          'Material List': 'Material List',
          Staff: 'Staff',
          Colors: 'Colors',
          Carriers: 'Carriers',
          Plys: 'Plys',
          Attachment: 'Attachment',
          Roles: 'Roles',
          'Production Process': 'Production Process',
          'Production Station': 'Production Station',
          Holidays: 'Holidays',
          Management: 'Management',
          Parts: 'Parts',
          Engineering: 'Engineering',
          'Part Assembly': 'Part Assembly',
          'Production Schedule': 'Production Schedule',
          CRM: 'CRM',
          Customers: 'Customers',
          Leads: 'Leads',
          Sources: 'Sources',
          Opportunity: 'Opportunity',
          Activity: 'Activity',
          'Order List': 'Order List',
          'Production Screen': 'Production Screen',
          'Packaging List': 'Packaging List',
          'Shipping List': 'Shipping List',
          'Modify Part Assembly': 'Modify Part Assembly',
          'Edit Customer': 'Edit Customer',
          'Order Item': 'Order Item',
          'Packaging Item': 'Packaging Item',
          'Shipment Item': 'Shipment Item',
          'Edit Role': 'Edit Role',
          'Change Password': 'Change Password',
          Permissions: 'Permissions',
          Attachments: 'Attachments',
          'Modify Opportunity': 'Modify Opportunity',
          'Sub Part': 'Sub Part',
          'Select Column to Show in Production Screen':
            'Select Column to Show in Production Screen',
          'Part Details': 'Part Details',
          'New Part': 'New Part',
          Report: 'Report',
          'User Activity': 'User Activity',
          'Open Orders': 'Open Orders',
          'Shipped Orders': 'Shipped Orders',
          'No Links Found': 'No Links Found',
          View: 'View',
          Edit: 'Edit',
          Add: 'Add',
          Delete: 'Delete',
          'Load More': 'Load More',
          Clone: 'Clone',
          Save: 'Save',
          'Save All': 'Save All',
          'Save changes': 'Save changes',
          'Add New Part': 'Add New Part',
          Cancel: 'Cancel',
          Remove: 'Remove',
          'Display Columns': 'Display Columns',
          Print: 'Print',
          'Start >>': 'Start >>',
          '<< Complete': '<< Complete',
          Makeup: 'Makeup',
          'Request a Makeup Quantity': 'Request a Makeup Quantity',
          'Request a Partial Quantity': 'Request a Partial Quantity',
          'Station History': 'Station History',
          Customer: 'Customer',
          Contact: 'Contact',
          Lead: 'Lead',
          Source: 'Source',
          Carrier: 'Carrier',
          Color: 'Color',
          Holiday: 'Holiday',
          Label: 'Label',
          Material: 'Material',
          'Drawing Link': 'Drawing Link',
          'PO Copy Link': 'PO Copy Link',
          'Select a Location': 'Select a Location',
          'Edit Customer Detail': 'Edit Customer Detail',
          Detail: 'Detail',
          'Edit Packaging Detail': 'Edit Packaging Detail',
          Ship: 'Ship',
          'Order Packaging': 'Order Packaging',
          Notes: 'Notes',
          Ply: 'Ply',
          Role: 'Role',
          'Ship to Location': 'Ship to Location',
          Select: 'Select',
          'Cancel Order': 'Cancel Order',
          'Update Workflow': 'Update Workflow',
          MultiplyBy: 'MultiplyBy',
          Complete: 'Complete',
          Today: 'Today',
          'Ship Details': 'Ship Details',
          Search: 'Search',
          'Clear All': 'Clear All',
          'Refresh Now': 'Refresh Now',
          'Packed Order': 'Packed Order',
          'Unpacked Order': 'Unpacked Order',
          Clear: 'Clear',
          Export: 'Export',
          'Estimation Details': 'Estimation Details',
          'Order Columns': 'Order Columns',
          'Billing Details': 'Billing Details',
          'Shipping Details': 'Shipping Details',
          SubTotal: 'SubTotal',
          'Sales Tax': 'Sales Tax',
          Estimations: 'Estimations',
          Bun: 'Bun',
          Manufacturer: 'Manufacturer',

          // productionScreen
          'Due Date': 'Due Date',
          'PO No': 'PO No',
          'Part Number': 'Part Number',
          Description: 'Description',
          'Core Guard Sleeve': 'Core Guard Sleeve',
          'Production Qty': 'Production Qty',
          'Width/Dim': 'Width/Dim',
          'Cut @': 'Cut @',
          Length: 'Length',
          'Angle Cut': 'Angle Cut',
          'Cut Header Size': 'Cut Header Size',
          'Part Drawing Link': 'Part Drawing Link',
          'General Note(Click to view)': 'General Note(Click to view)',
          'Specific Note(Click to view)': 'Specific Note(Click to view)',
          'Date Time Started': 'Date Time Started',
          'Staff Name': 'Staff Name',
          Start: 'Start',
          'Makeup Qty': 'Makeup Qty',
          'Makeup Note': 'Makeup Note',

          // Production Screen - Bandsaw Table
          'PO Count': 'PO Count',
          'Total Qty': 'Total Qty',
          'Cut / Header Size': 'Cut / Header Size',

          // Production Screen - Table Number Modal
          'Add Table Number': 'Add Table Number',
          'Table Number': 'Table Number',

          // Production Screen - Notes Modal
          'Specific Notes': 'Specific Notes',
          'No Notes Found': 'No Notes Found',

          // Production Screen - login Modal
          Username: 'Username',
          Password: 'Password',

          //Production Screen - PartialQty Modal
          'Production Id': 'Production Id',
          'Parent Order Item Id': 'Parent Order Item Id',
          'Partial Qty': 'Partial Qty',
          'Partial Note': 'Partial Note',

          //Production Screen - makeupQty Modal
          Qty: 'Qty',
          Station: 'Station',

          //OrderListPage
          'Order Id': 'Order Id',
          'Customer Name': 'Customer Name',
          'PO Number': 'PO Number',
          'Received Date': 'Received Date',
          Terms: 'Terms',
          'Package Date': 'Package Date',
          'Ship Date': 'Ship Date',

          // OrderEntry
          'Note To Production Team Specific':
            'Note To Production Team Specific',
          'Current Station': 'Current Station',

          // addNewPart
          'Gallop Part Number': 'Gallop Part Number',

          // Label
          'Label Number': 'Label Number',
          'Label Description': 'Label Description',
          'Core Guard': 'Core Guard',

          // addPartModal
          'Finished Qty': 'Finished Qty',
          'Add Blank Rows': 'Add Blank Rows',
          'Reduce Record Label Qty by 1/2': 'Reduce Record Label Qty by 1/2',
          Action: 'Action',

          // Package History
          ID: 'ID',
          'Packaged Date': 'Packaged Date',
          'Packaging Status': 'Packaging Status',
          'Packaged By': 'Packaged By',
          'Item Shipped': 'Item Shipped',

          // DimensionAndWeight
          'Number of boxes': 'Number of boxes',
          'Number of Cores': 'Number of Cores',
          'Number of Pallets': 'Number of Pallets',
          Weight: 'Weight',
          Width: 'Width',
          Height: 'Height',

          // orderChangeLog
          'Change Note': 'Change Note',
          'Change Field': 'Change Field',
          'Change From': 'Change From',
          'Change To': 'Change To',
          'Change Date': 'Change Date',
          'Order Line Item Id': 'Order Line Item Id',

          // LoadingInstruction
          'Loading Instructions Applicable Document(s)':
            'Loading Instructions Applicable Document(s)',

          // OtherLinkPage
          'Other Link Description': 'Other Link Description',
          Link: 'Link',
          'Viewable In Packaging Area?': 'Viewable In Packaging Area?',

          // Packaging Screen
          'Order ID': 'Order ID',
          'PO Notes': 'PO Notes',
          'PO Date': 'PO Date',
          'Order Date': 'Order Date',
          'Production Scheduled Start Date': 'Production Scheduled Start Date',

          // Packaging Screen - Detail Tab
          'Production Completed': 'Production Completed',
          'Production Completed Date': 'Production Completed Date',
          'MakeUp Request': 'MakeUp Request',

          // Shipment Screen - Detail Tab
          'Ship Via': 'Ship Via',
          'Shipped By': 'Shipped By',
          'Tracking Number': 'Tracking Number',
          Email: 'Email',

          // Shipment Screen - Ship Link Tab
          'Link Description': 'Link Description',
          'Bol Link': 'Bol Link',

          // Shipment Screen - Carrier Order Tab
          'Next Day Air': '	Next Day Air',

          // ShipmentItem - Tab Text
          'Carrier Order': 'Carrier Order',
          'Completed Shipment': 'Completed Shipment',
          'Dimension and Weight': 'Dimension and Weight',
          'Order Shipment': 'Order Shipment',
          'Loading Instruction': 'Loading Instruction',
          'Ship Link': 'Ship Link',

          // PackagingItem - Tab Text
          'Other Link': 'Other Link',
          'Packaging Details': 'Packaging Details',

          // OrderItem Tab Text
          'Order Change Log': 'Order Change Log',
          'Order Item Change Log': 'Order Item Change Log',

          // Admin
          'Report Sort': 'Report Sort',
          Sort: 'Sort',
          'Show In Packing': 'Show In Packing',
          'Addition To Length': 'Addition To Length',
          'Multiply By': 'Multiply By',
          'Add Length 2 Ply Welting': 'Add Length 2 Ply Welting',
          'Utilization Bun Calculation': 'Utilization Bun Calculation',
          'Angle Item': 'Angle Item',
          Inactive: 'Inactive',
          Name: 'Name',
          'Add Role': 'Add Role',
          Process: 'Process',
          'Show In Fabrication Report': 'Show In Fabrication Report',
          'LeadTime (No. of Days)': 'LeadTime (No. of Days)',
          ShowTableNo: 'ShowTableNo',
          InActive: 'InActive',
          'Allow Multi Login': 'Allow Multi Login',
          'Allow Complete 1': 'Allow Complete 1',
          'Display Qty': 'Display Qty',
          'Finish Qty Override': 'Finish Qty Override',
          'Column To Show': 'Column To Show',
          Date: 'Date',
          'Bun Qty': 'Bun Qty',
          Spacer: 'Spacer',
          'Finger Row': 'Finger Row',
          'Finger Thickness': 'Finger Thickness',

          // Managment
          'Min Qty': 'Min Qty',
          'Max Qty': 'Max Qty',
          Cost: 'Cost',
          'Raw Good Barcode': 'Raw Good Barcode',
          Bin: 'Bin',
          'Reorder Level': 'Reorder Level',

          // Part Assembly
          'Part Assembly Number': 'Part Assembly Number',
          'Assembly Name': 'Assembly Name',
          'Link To Label': 'Link To Label',
          'Finished Good Barcode Num': 'Finished Good Barcode Num',
          'Order Entry Multiply by2': 'Order Entry Multiply by2',

          // CRM - Customer
          City: 'City',
          State: 'State',
          ZIP: 'ZIP',
          Country: 'Country',
          'Payment Terms': 'Payment Terms',

          // Customer - Tab Text
          'Ship To Locations': 'Ship To Locations',
          Estimation: 'Estimation',
          Communication: 'Communication',
          Orders: 'Orders',

          // Customer - ShipToLocation
          'Ship To Customer Name': 'Ship To Customer Name',
          Address1: 'Address1',
          Address2: 'Address2',
          'Shipping Instructions': 'Shipping Instructions',

          // Customer - ContactListPage
          'Contact Name': 'Contact Name',
          Title: 'Title',
          CellPhone: 'CellPhone',
          Phone: 'Phone',
          'Shipping Notification': 'Shipping Notification',

          // Customer - Orders
          'Ship via': 'Ship via',
          'Tracking No': 'Tracking No',

          // Customer - Communication
          Type: 'Type',
          'Customer Contact Name': 'Customer Contact Name',
          'Communication Date': 'Communication Date',

          // CRM - Estimation
          'Estimate #': 'Estimate #',
          'Estimate Date': 'Estimate Date',
          FOBr: 'FOB',
          'Convert To Order': 'Convert To Order',
          Active: 'Active',

          // EstimationDetail
          Taxable: 'Taxable',
          'Percent Discount': 'Percent Discount',
          Total: 'Total',
          'Print Estimation': 'Print Estimation',

          // CRM - leads
          'Lead Owner': 'Lead Owner',
          'First Name': 'First Name',
          'Last Name': 'Last Name',
          Company: 'Company',
          'Contact Number': 'Contact Number',
          'Lead Status': 'Lead Status',
          'Lead Source': 'Lead Source',
          'Convert To Opportunity': 'Convert To Opportunity',

          // CRM - Sources
          'Source Name': 'Source Name',
          'Is Active': 'Is Active',

          // CRM - Opportunity
          'Sr No.': 'Sr No.',
          'Opportunity Name': 'Opportunity Name',
          'Close Date': 'Close Date',
          'Expected Revenue': 'Expected Revenue',
          Stage: 'Stage',
          Reason: 'Reason',

          // CRM - Activity
          Subject: 'Subject',
          'Assigned To': 'Assigned To',
          Status: 'Status',
          Priority: 'Priority',
          'Type/Category': 'Type/Category',
          'Description/Notes': 'Description/Notes',
          'Related To': 'Related To',
          'Completion Date': 'Completion Date',
          'Outcome/Result': 'Outcome/Result',
          'Duration/Time Spent': 'Duration/Time Spent',
          'Linked Contacts/Users': 'Linked Contacts/Users',
          'Location/Meeting Room': 'Location/Meeting Room',
          'Related Campaign': 'Related Campaign',
          'Follow-up Action': 'Follow-up Action',
          'Comments/Communication': 'Comments/Communication',
          'Reminders/Alerts': 'Reminders/Alerts',
          Recurring: 'Recurring',

          // CRM - Cost Method
          'Use Width': 'Use Width',
          'Use Length': 'Use Length',
          'Cost Method': 'Cost Method',

          // CRM - Component Master
          'Cost Value': 'Cost Value',
          'Component Master': 'Component Master',
          'Component Number': 'Component Number',

          // CRM - Part Component
          Part: 'Part',
          Table: 'Table',
          'Sub Part/Component': 'Sub Part/Component',
          'Part Component': 'Part Component',

          // Reports
          'Makeup Report': 'MakeUp Report',
          'Percentage (%)': 'Percentage (%)',
          Fabrication: 'Fabrication',
          Emergency: 'Emergency',
          'Managers Activity': 'Managers Activity',
          'Date Time Ended': 'Date Time Ended',
          'This Week': 'This Week',
          'Last Week': 'Last Week',
          Yesterday: 'Yesterday',
          'Sub Total': 'Sub Total',
          'Last 7 Days': 'Last 7 Days',
          'Last 15 Days': 'Last 15 Days',
          'Last 30 Days': 'Last 30 Days',
        },
      },
      es: {
        translations: {
          'Order Management System': 'Sistema de gestión de pedidos',
          Dashboard: 'Panel',
          Admin: 'administración',
          'Material List': 'Lista de Materiales',
          Staff: 'Personal',
          Colors: 'Colores',
          Carriers: 'Portadoras',
          Plys: 'Capas',
          Attachment: 'Adjunto',
          Roles: 'Roles',
          'Production Process': 'Proceso de Producción',
          'Production Station': 'Estación de Producción',
          Holidays: 'Vacaciones',
          Management: 'Gestión',
          Parts: 'Partes',
          Engineering: 'Engineering',
          'Part Assembly': 'Ensamblaje de Piezas',
          'Production Schedule': 'Horario de Produccion',
          'Web Details' : 'Detalles web',
          'Weight Entry' : 'Entrada de peso',
          'Widget Setup' : 'Configuración de widgets',
          'Engineering' : 'Ingeniería',
          'Web Orders':'Pedidos web',
          'Estimates':'Estimadas',
          'Tracking Reports':'Informes de seguimiento',
          'Customer Orders':'Pedidos de los clientes',
          'Shop Item':'Artículo de la tienda',
          'Category':'Categoría',
          'Carousel Image' :'Imagen del carrusel',
          'Scheduled Orders' : 'Órdenes programadas',
          'Unscheduled Orders' : 'Órdenes no programadas',
          CRM: 'CRM',
          Customers: 'Clientes',
          Leads: 'Dirige',
          Sources: 'Fuentes',
          Opportunity: 'Oportunidad',
          Activity: 'Actividad',
          'Order List': 'Orden Lis',
          'Production Screen': 'Pantalla de Producción',
          'Packaging List': 'Lista de Embalaje',
          'Shipping List': 'Lista de Embarque',
          'Modify Part Assembly': 'Modificar Ensamblaje De Piezas',
          'Edit Customer': 'Editar Cliente',
          'Order Item': 'Articulo Ordenado',
          'Packaging Item': 'Artículo De Embalaje',
          'Shipment Item': 'Artículo De Envío',
          'Edit Role': 'Editar Rol',
          'Change Password': 'Cambiar La Contraseña',
          Permissions: 'Permisos',
          Attachments: 'Archivos adjuntos',
          'Modify Opportunity': 'Modificar oportunidad',
          'Sub Part': 'Subparte',
          'Select Column to Show in Production Screen':
            'Seleccione la columna para mostrar en la pantalla de producción',
          'Part Details': 'Detalles de la pieza',
          'New Part': 'Parte nueva',
          Report: 'Informe',
          'User Activity': 'Actividad del usuario',
          'Open Orders': 'Ordenes abiertas',
          'Shipped Orders': 'Pedidos enviados',
          'No Links Found': 'no se encontraron enlaces',
          View: 'Vista',
          Edit: 'Editar',
          Add: 'Agregar',
          Delete: 'Borrar',
          'Load More': 'Carga más',
          Clone: 'Clon',
          Save: 'Ahorrar',
          'Save All': 'Salvar a todos',
          'Save changes': 'Guardar cambios',
          'Add New Part': 'Agregar nueva pieza',
          Cancel: 'Cancelar',
          Remove: 'Eliminar',
          'Display Columns': 'Mostrar columnas',
          Print: 'Imprimir',
          'Start >>': 'Inicio >>',
          '<< Complete': '<< Completa',
          Makeup: 'Constituir',
          'Request a Makeup Quantity': 'Solicitar una cantidad de maquillaje',
          'Request a Partial Quantity': 'Solicitar una cantidad parcial',
          'Station History': 'Historial de la estación',
          Customer: 'Cliente',
          Contact: 'Contacto',
          Lead: 'Dirigir',
          Source: 'Fuente',
          Carrier: 'Transportadora',
          Color: 'Color',
          Holiday: 'Día festivo',
          Label: 'Etiqueta',
          Material: 'Material',
          'Drawing Link': 'Enlace de dibujo',
          'PO Copy Link': 'Enlace de copia de orden de compra',
          'Select a Location': 'Selecciona una ubicación',
          'Edit Customer Detail': 'Editar detalles del cliente',
          Detail: 'Detalle',
          'Edit Packaging Detail': 'Editar detalle de embalaje',
          Ship: 'Barco',
          'Order Packaging': 'Embalaje del Notes',
          Notes: 'Notas',
          Ply: 'Capa',
          Role: 'rol',
          'Ship to Location': 'Enviar a la ubicación',
          Select: 'Seleccionar',
          'Cancel Order': 'Cancelar orden',
          'Update Workflow': 'Actualizar flujo de trabajo',
          MultiplyBy: 'Multiplicar por',
          Complete: 'Completo',
          Today: 'Hoy',
          'Ship Details': 'Detalles del barco',
          Search: 'Buscar',
          'Clear All': 'Limpiar todo',
          'Refresh Now': 'Refresca ahora',
          'Packed Order': 'orden empaquetada',
          'Unpacked Order': 'Orden desempaquetada',
          Clear: 'Claro',
          Export: 'Exportar',
          'Estimation Details': 'Agregar detalles de estimación',
          'Order Columns': 'Ordenar columnas',
          'Billing Details': 'Detalles de facturación',
          'Shipping Details': 'Detalles de envío',
          SubTotal: 'Total parcial',
          'Sales Tax': 'Impuesto de venta',
          Estimations: 'Estimaciones',
          Bun: 'Bolla',
          Manufacturer: 'Fabricante',

          // ProductionScreen
          'Due Date': 'Fecha de Vencimiento',
          'PO No': 'Número de Pedido',
          'Part Number': 'Número de Parte',
          Description: 'Descripción',
          'Core Guard Sleeve': 'Manga Protectora de Núcleo',
          'Production Qty': 'Cantidad de Producción',
          'Width/Dim': 'Ancho/Dimensión',
          'Cut @': 'Cortar en',
          Length: 'Longitud',
          'Angle Cut': 'Corte en Ángulo',
          'Cut Header Size': 'Tamaño de Cabecera de Corte',
          'Part Drawing Link': 'Enlace del Dibujo de la Pieza',
          'General Note(Click to view)': 'Nota General (Haga clic para ver)',
          'Specific Note(Click to view)':
            'Nota Específica (Haga clic para ver)',
          'Date Time Started': 'Fecha y Hora de Inicio',
          'Staff Name': 'Nombre del Personal',
          Start: 'Iniciar',
          'Makeup Qty': 'Cantidad de Maquillaje',
          'Makeup Note': 'Nota de Maquillaje',

          // Production Screen - Bandsaw Table
          'PO Count': 'Cantidad de Órdenes de Compra',
          'Total Qty': 'Cantidad Total',
          'Cut / Header Size': 'Tamaño de Corte / Cabecera',

          // Production Screen - Table Number Modal
          'Add Table Number': 'Agregar número de mesa',
          'Table Number': 'Número de mesa',

          // Production Screen - Notes Modal
          'Specific Notes': 'Notas específicas',
          'No Notes Found': 'No se encontraron notas',

          // Production Screen - login Modal
          Username: 'No se encontraron notas',
          Password: 'Contraseña',

          //Production Screen - PartialQty Modal
          'Production Id': 'ID de Producción',
          'Parent Order Item Id': 'ID de Elemento de Orden Padre',
          'Partial Qty': 'Cantidad Parcial',
          'Partial Note': 'Nota Parcial',

          //Production Screen - makeupQty Modal
          Qty: 'Cantidad',
          Station: 'Estación',

          // OrderListPage
          'Order Id': 'ID de Orden',
          'Customer Name': 'Nombre del Cliente',
          'PO Number': 'Número de Orden de Compra',
          'Received Date': 'Fecha de Recepción',
          Terms: 'Términos',
          'Package Date': 'Fecha de Empaque',
          'Ship Date': 'Fecha de Envío',

          // OrderEntry
          'Current Station': 'Estación actual',
          'Note To Production Team Specific':
            'Nota para el equipo de producción específica',

          // addNewPart
          'Gallop Part Number': 'Número de Parte Gallop',

          // Label
          'Label Number': 'Número de etiqueta',
          'Label Description': 'Descripción de la etiqueta',
          'Core Guard': 'Guardia central',

          // addPartModal
          'Finished Qty': 'Cantidad terminada',
          'Add Blank Rows': 'Agregar filas en blanco',
          'Reduce Record Label Qty by 1/2':
            'Reducir la cantidad de etiquetas discográficas a la mitad',
          Action: 'Acción',

          // Package History
          ID: 'IDENTIFICACIÓN',
          'Packaged Date': 'Fecha de Empaque',
          'Packaging Status': 'Estado de Empaque',
          'Packaged By': 'Empacado Por',
          'Item Shipped': 'Artículo Enviado',

          // DimensionAndWeight
          'Number of boxes': 'Número de Cajas',
          'Number of Cores': 'Número de Núcleos',
          'Number of Pallets': 'Número de Paletas',
          Weight: 'Peso',
          Width: 'Ancho',
          Height: 'Altura',

          // orderChangeLog
          'Change Note': 'Nota de Cambio',
          'Change Field': 'Campo de Cambio',
          'Change From': 'Cambio Desde',
          'Change To': 'Cambio A',
          'Change Date': 'Fecha de Cambio',
          'Order Line Item Id': 'ID de artículo de línea de pedido',

          // LoadingInstruction
          'Loading Instructions Applicable Document(s)':
            'Instrucciones de carga Documento(s) aplicable(s)',

          // OtherLinkPage
          'Other Link Description': 'Descripción de Otro Enlace',
          Link: 'Enlace',
          'Viewable In Packaging Area?': '¿Visible en el Área de Empaque?',

          // Packaging Screen
          'Order ID': 'ID de Orden',
          'PO Notes': 'Notas de Orden de Compra',
          'PO Date': 'Fecha de Orden de Compra',
          'Order Date': 'Fecha de Orden',
          'Production Scheduled Start Date':
            'Fecha de Inicio Programada de Producción',

          // Packaging Screen - Detail Tab
          'Production Completed': 'Producción completada',
          'Production Completed Date': 'Fecha de finalización de la producción',
          'MakeUp Request': 'Solicitud de maquillaje',

          // Shipment Screen - Detail Tab
          'Ship Via': 'Envío a través de',
          'Shipped By': 'Enviado Por',
          'Tracking Number': 'Número de Seguimiento',
          Email: 'Correo Electrónico',

          // Shipment Screen - Ship Link Tab
          'Link Description': 'direccion de enlace en la descripcion',
          'Bol Link': 'enlace Bol',

          // Shipment Screen - Order Shipment Tab
          'Next Day Air': 'Aire al día siguiente',

          // ShipmentItem - Tab Text
          'Carrier Order': 'Orden del transportista',
          'Completed Shipment': 'Envío completado',
          'Dimension and Weight': 'Dimensión y peso',
          'Order Shipment': 'Envío de pedido',
          'Loading Instruction': 'Instrucción de carga',
          'Ship Link': 'Enlace de barco',

          // PackagingItem - Tab Text
          'Other Link': 'Otro enlace',
          'Packaging Details': 'detalles del empaque',

          // OrderItem Tab Text
          'Order Change Log': 'Registro de cambios de pedido',
          'Order Item Change Log': 'Registro de cambios de artículos de pedido',

          // Admin
          'Report Sort': 'Ordenar informe',
          Sort: 'Clasificar',
          'Show In Packing': 'Mostrar en embalaje',
          'Addition To Length': 'Adición a la longitud',
          'Multiply By': 'Multiplicar por',
          'Add Length 2 Ply Welting':
            'Agregar longitud de soldadura de 2 capas',
          'Utilization Bun Calculation': 'Cálculo del bollo de utilización',
          'Angle Item': 'Artículo de ángulo',
          Inactive: 'Inactivo',
          Name: 'Nombre',
          'Add Role': 'Agregar rol',
          Process: 'Proceso',
          'Show In Fabrication Report': 'Mostrar en informe de fabricación',
          'LeadTime (No. of Days)': 'Plazo de entrega (número de días)',
          ShowTableNo: 'Mostrar Número de Mesa',
          InActive: 'Inactivo',
          'Allow Multi Login': 'Permitir inicio de sesión múltiple',
          'Allow Complete 1': 'Permitir Completado 1',
          'Display Qty': 'Cantidad de pantalla',
          'Finish Qty Override': 'Finalizar anulación de cantidad',
          'Column To Show': 'Columna para mostrar',
          Date: 'Fecha',
          'Bun Qty': 'Cantidad de panecillos',
          Spacer: 'Espaciador',
          'Finger Row': 'Fila de Dedos',
          'Finger Thickness': 'Grosor de los dedos',

          // Managment
          'Min Qty': 'Cantidad mínima',
          'Max Qty': 'Cantidad máxima',
          Cost: 'Costo',
          'Raw Good Barcode': 'Buen código de barras sin procesar',
          Bin: 'Papelera',
          'Reorder Level': 'Reordenar nivel',
          // Part Assembly
          'Part Assembly Number': 'Número de ensamblaje de pieza',
          'Assembly Name': 'Nombre de la Asamblea',
          'Link To Label': 'Enlace a la etiqueta',
          'Finished Good Barcode Num':
            'Número de código de barras bueno terminado',
          'Order Entry Multiply by2': 'Entrada de orden Multiplicar por 2',

          // CRM - Customer
          City: 'Ciudad',
          State: 'Estado',
          ZIP: 'CREMALLERA',
          Country: 'País',
          'Payment Terms': 'Términos de pago',

          // Customer - Tab Text
          'Ship To Locations': 'Enviar a ubicaciones',
          Estimation: 'Estimacion',
          Communication: 'Comunicación',
          Orders: 'Pedidos',

          // Customer - ShipToLocation
          'Ship To Customer Name': 'Envío al nombre del cliente',
          Address1: 'Dirección 1',
          Address2: 'Dirección 2',
          'Shipping Instructions': 'Instrucciones de envío',

          // Customer - ContactListPage
          'Contact Name': 'Nombre de contacto',
          Title: 'Título',
          CellPhone: 'Teléfono móvil',
          Phone: 'Teléfono',
          'Shipping Notification': 'Notificación de envío',

          // Customer - Orders
          'Ship via': 'Embarcar vía',
          'Tracking No': 'Rastreando no',

          // Customer - Communication
          Type: 'Tipo',
          'Customer Contact Name': 'Nombre de contacto del cliente',
          'Communication Date': 'Fecha de comunicación',

          // CRM - Estimation
          'Estimate #': 'Estimar #',
          'Estimate Date': 'Fecha estimada',
          FOBr: 'ENGAÑAR',
          'Convert To Order': 'Convertirse en orden',
          Active: 'Activa',

          // EstimationDetail
          Taxable: 'Imponible',
          'Percent Discount': 'Porcentaje de descuento',
          Total: 'total',
          'Print Estimation': 'Estimación de impresión',

          // CRM - leads
          'Lead Owner': 'Propietario',
          'First Name': 'Nombre de pila',
          'Last Name': 'Apellido',
          Company: 'Compañía',
          'Contact Number': 'Número de contacto',
          'Lead Status': 'Estado de plomo',
          'Lead Source': 'Fuente principal',
          'Convert To Opportunity': 'Convertirse en oportunidad',

          // CRM - Sources
          'Source Name': 'Nombre de la fuente',
          'Is Active': 'Está activo',

          // CRM - Opportunity
          'Sr No.': 'No Señor.',
          'Opportunity Name': 'Nombre de oportunidad',
          'Close Date': 'Fecha de cierre',
          'Expected Revenue': 'Los ingresos esperados',
          Stage: 'Escenario',
          Reason: 'Razón',

          // CRM - Activity
          Subject: 'Sujeto',
          'Assigned To': 'Asignado a',
          Status: 'Estado',
          Priority: 'Prioridad',
          'Type/Category': 'Tipo/categoría',
          'Description/Notes': 'Descripción/notas',
          'Related To': 'Relacionado con',
          'Completion Date': 'Fecha de Terminación',
          'Outcome/Result': 'Resultado/resultado',
          'Duration/Time Spent': 'Duración/tiempo dedicado',
          'Linked Contacts/Users': 'Contactos/usuarios vinculados',
          'Location/Meeting Room': 'Ubicación/sala de reuniones',
          'Related Campaign': 'Campaña relacionada',
          'Follow-up Action': 'Acción de seguimiento',
          'Comments/Communication': 'Comentarios/comunicación',
          'Reminders/Alerts': 'Recordatorios/alertas',
          Recurring: 'Periódica',

          // CRM - Cost Method
          'Use Width': 'Usar ancho',
          'Use Length': 'Usar longitud',
          'Cost Method': 'Método de costos',

          // CRM - Component Master
          'Cost Value': 'Valor de coste',
          'Component Master': 'Maestro de componentes',
          'Component Number': 'Número de componente',

          // CRM - Part Component
          Part: 'Parte',
          Table: 'Mesa',
          'Sub Part/Component': 'Sub Parte/Componente',
          'Part Component': 'Componente parcial',

          // Reports
          'Makeup Report': 'Informe de maquillaje',
          'Percentage (%)': 'Porcentaje (%)',
          Fabrication: 'Fabricación',
          Emergency: 'Emergencia',
          'Managers Activity': 'Actividad de los gerentes',
          'Date Time Ended': 'Fecha de hora finalizada',
          'This Week': 'Esta semana',
          'Last Week': 'La semana pasada',
          Yesterday: 'Ayer',
          'Sub Total': 'Subcontrol',
          'Last 7 Days': 'Los últimos 7 días',
          'Last 15 Days': 'Últimos 15 días',
          'Last 30 Days': 'Últimos 30 días',
        },
      },
    },
    fallbackLng: 'en',
    debug: false,

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
